import { Printer, CheckCircle2 } from 'lucide-react';
import { PriceBox } from '@generated/components/PriceBox';
import { PayPanel } from '@generated/components/PayPanel';
import type { Quote } from '@generated/components/pricing';

interface Props { orderId: string; lines: [string, string][]; q: Quote; deadline: string; onNew: () => void; onBack?: () => void; uploadNote: string | null; method: string; dueNow: number; monthly: boolean; email?: string; isEvent?: boolean; onPlanCampaign?: () => void }

export function Confirmation({ orderId, lines, q, deadline, onNew, onBack, uploadNote, method, dueNow, monthly, email, isEvent, onPlanCampaign }: Props) {
  return (
    <div className="mx-auto max-w-3xl">
      <div className="text-center">
        <CheckCircle2 className="mx-auto h-10 w-10 text-primary" />
        <h2 className="mt-3 font-[family-name:var(--font-heading)] text-4xl font-semibold">Thank you — your order is in.</h2>
        <p className="mt-2 text-sm text-muted-foreground">Order #{orderId} · George will confirm your placement within one business day.</p>
      </div>
      <div className="mt-8 grid gap-6 border-y-4 border-double border-foreground py-6 md:grid-cols-[1fr_300px]">
        <dl className="divide-y divide-border text-sm">
          {lines.map(([k, v]) => (
            <div key={k} className="flex justify-between gap-4 py-2"><dt className="text-muted-foreground">{k}</dt><dd className="text-right font-medium">{v || '—'}</dd></div>
          ))}
        </dl>
        <PriceBox q={q} title="Receipt" />
      </div>
      <PayPanel method={method} orderId={orderId} dueNow={dueNow} total={q.total} monthly={monthly} email={email} kind="Display ad" />
      {onBack && <p className="mt-3 text-center text-xs text-muted-foreground print:hidden">Having second thoughts? <button type="button" onClick={onBack} className="underline underline-offset-2 hover:text-foreground">Go back and change your order</button> before paying.</p>}
      <div className="mt-6 space-y-2 text-sm">
        <p><strong>Artwork deadline:</strong> {deadline}. Send files to gbrook8344@gmail.com if not already uploaded.</p>
        {uploadNote && <p className="text-destructive">{uploadNote}</p>}
        <p><strong>Questions?</strong> George Fiala, Publisher · 917-652-9128 · gbrook8344@gmail.com · www.star-revue.com</p>
      </div>
      <div className="mt-8 flex flex-wrap gap-3 print:hidden">
        <button onClick={() => window.print()} className="inline-flex min-h-11 items-center gap-2 border border-foreground px-5 text-sm font-semibold hover:bg-muted"><Printer className="h-4 w-4" />Print receipt</button>
        {isEvent && onPlanCampaign && (
          <div className="w-full border-2 border-[hsl(var(--brand-blue))] bg-card p-4 text-left">
            <div className="font-[family-name:var(--font-heading)] text-lg font-semibold">Keep readers coming back after your event</div>
            <p className="mt-1 text-sm text-muted-foreground">Advertisers who run for 3 months or more pay a lower monthly rate, and stay in front of the same neighbors every issue.</p>
            <button onClick={onPlanCampaign} className="mt-3 min-h-11 bg-[hsl(var(--brand-blue))] px-4 text-sm font-semibold text-primary-foreground">Plan an ongoing campaign</button>
          </div>
        )}
        <button onClick={onNew} className="min-h-11 bg-primary px-5 text-sm font-semibold text-primary-foreground hover:bg-primary/90">Place another ad</button>
      </div>
    </div>
  );
}
